/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const invoiceSummaryDataSchema = z.object({
	unpaid: z.object({ count: z.number(), amount: z.number(), currency: z.string() }),
	overdue: z.object({ count: z.number(), amount: z.number(), currency: z.string() }),
})

export type InvoiceSummaryDataSchema = z.infer<typeof invoiceSummaryDataSchema>
